import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan, faSave } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

import { RemoveButton } from './Connector.styled'

export const ConnectionActionButton = ({
  isExistingConnection,
  onClick,
  isLoading,
}: {
  isExistingConnection: boolean
  onClick: () => void
  isLoading?: boolean
}) => {
  return (
    <RemoveButton disabled={isLoading} onClick={onClick}>
      <FontAwesomeIcon
        icon={isExistingConnection ? (faTrashCan as IconProp) : (faSave as IconProp)}
      />
    </RemoveButton>
  )
}
